import { render, staticRenderFns } from "./SelectPrescriptionForm.vue?vue&type=template&id=1d47c5f2&scoped=true"
import script from "./SelectPrescriptionForm.vue?vue&type=script&lang=js"
export * from "./SelectPrescriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47c5f2",
  null
  
)

export default component.exports